// @flow
import * as React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Container, Row, Col } from 'reactstrap';

import { loadTopics } from 'actions/topics';
import type { Topic as TopicType } from 'actions/topics';

import ImageTextListItem from 'components/ImageTextListItem';
import ReportState from 'components/ReportState';

import NewTopic from './NewTopic';

type Props = {
  // redux
  topics: Array<TopicType>,
  onLoadTopics: typeof loadTopics,
};

class Topics extends React.Component<Props> {
  componentDidMount() {
    this.props.onLoadTopics();
  }

  render() {
    const { topics } = this.props;

    return (
      <div className="animated fadeIn">
        <Container fluid>
          <Row>
            <Col>
              {topics.map(topic => (
                <Link
                  key={topic.topicId}
                  to={`/topic/${topic.topicId}`}
                  style={{ textDecoration: 'none', color: 'inherit' }}
                >
                  <ImageTextListItem
                    title={topic.title}
                    description={topic.description}
                    image={topic.images.length > 0 ? topic.images[0] : null}
                    createdAt={topic.createdAt}
                    likesCount={topic.likes.length}
                    commentsCount={topic.comments.length}
                    statusComponent={
                      !!topic.deleted ? <ReportState state="deleted" /> : null
                    }
                  />
                </Link>
              ))}
            </Col>
            <Col xs="12" sm="12" md="12" lg="5" xl="5">
              <NewTopic />
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

const mapStateToProps = ({ topics: { all: topics } }) => ({
  topics,
});
const mapDispatchToProps = dispatch => ({
  onLoadTopics: (...args) => dispatch(loadTopics(...args)),
});

const TopicsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Topics);

export default TopicsContainer;



// WEBPACK FOOTER //
// ./src/views/Topics/Topics.js